<div>

    <button style="margin: 10px !important;" type="button" class="close" aria-label="Close" (click)="_close()">
        <span aria-hidden="true">&times;</span>
    </button>

    <ngb-tabset>
        <ngb-tab title="General">
            <ng-template ngbTabContent let-modal>
                <div class="modal-header">
                    <h4 class="modal-title" id="modal-basic-title" *ngIf="!editar">Nuevo contacto</h4>
                    <h4 class="modal-title" id="modal-basic-title" *ngIf="editar">Editar contacto</h4>
                </div>
                <div class="modal-body pl-4">
                    <form action="" #form="ngForm" autocomplete="off">

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                            <label *ngIf="editar" class="col-md-2 label-size tsiLabel mt-2">Código</label>
                            <div *ngIf="editar" class="col-sm-4">
                                <input class="form-control tsiInput" name="contacto.codcont"
                                    [(ngModel)]="contacto.codcont" type="text" maxlength="3" disabled>
                            </div>
                            <div class="col-md-1">
                                <app-custom-switch [(valor)]="checkActivo" [identificador]="'1'"></app-custom-switch>
                            </div>

                        </div>

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                            <label class="col-md-2 label-size tsiLabel mt-2">Nombre:</label>
                            <div class="col-sm-9">
                                <input class="form-control tsiInput" name="contacto.nomcont" #nomcont
                                    [(ngModel)]="contacto.nomcont" type="text" maxlength="100" tabindex="600">
                            </div>
                            <span style="color: red; font: sans-serif; margin-left: -17px">(*)</span>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                            <label class="col-md-2 label-size tsiLabel mt-2">Dirección:</label>
                            <div class="col-sm-10">
                                <input class="form-control tsiInput" name="contacto.direccion"
                                    [(ngModel)]="contacto.direccion" type="text" maxlength="100" tabindex="601">
                            </div>
                        </div>

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                            <label class="col-md-2 label-size tsiLabel mt-2">Hobby:</label>
                            <div class="col-sm-10">
                                <input class="form-control tsiInput" name="contacto.hobby" [(ngModel)]="contacto.hobby"
                                    type="text" maxlength="30" tabindex="602">
                            </div>
                        </div>


                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                            <label class="col-md-2 label-size tsiLabel mt-2">Teléfono:</label>
                            <div class="col-sm-10">
                                <input class="form-control tsiInput" name="contacto.telefono"
                                    [(ngModel)]="contacto.telefono" type="text" maxlength="30" tabindex="603">
                            </div>
                        </div>


                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                            <label class="col-md-2 label-size tsiLabel mt-2">Correo:</label>
                            <div class="col-sm-10">
                                <input class="form-control tsiInput" name="contacto.email" [(ngModel)]="contacto.email"
                                    type="text" maxlength="100" tabindex="604">
                            </div>
                        </div>

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                            <label class="col-md-2 label-size tsiLabel mt-2">Cargo:</label>
                            <div class="col-sm-10">
                                <input class="form-control tsiInput" id="cargo" name="contacto.cargo"
                                    [(ngModel)]="contacto.cargo" type="text" maxlength="100" tabindex="605">
                            </div>
                        </div>

                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                            <label class="col-md-2 label-size tsiLabel mt-2">Observación:</label>
                            <div class="col-sm-10">
                                <input class="form-control tsiInput" id="cargo" name="contacto.observ"
                                    [(ngModel)]="contacto.observ" type="text" maxlength="1000" tabindex="605">
                            </div>
                        </div>
                        <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px"> <!---->
                            <label class="col-md-2 label-size tsiLabel mt-2">Felicitación:</label>
                            <div class="col-sm-10">
                                <input class="form-control tsiInput col-md-3" name="contacto.felicitacion"
                                    [(ngModel)]="contacto.felicitacion" type="date">
                            </div>
                        </div>

                    </form>

                </div>
                <div class="modal-footer">

                    <button class="btn btn-rounded btn-info" type="button" (click)="_success()" *ngIf="!editar"
                        tabindex="607"><i class="fa fa-save"></i> Guardar</button>
                    <button class="btn btn-rounded btn-info" type="button" (click)="_actualizar()" *ngIf="editar"
                        tabindex="607"> <i class="fa fa-save"></i> Guardar</button>
                    <button (keydown.tab)="onNexFocus('nuevo')" tabindex="608" type="button"
                        class="btn btn-rounded btn-warning" (click)="_close()"><i class="fa fa-times-circle"></i>
                        Cancelar</button>
                </div>
            </ng-template>
        </ngb-tab>


        <ngb-tab *ngIf="editar">
            <ng-template ngbTabTitle><b>Clases</b></ng-template>
            <ng-template ngbTabContent let-modal>

                <div class="modal-header">
                    <div>
                        <button type="button" class="btn btn-rounded btn-success m-b-15"
                            (click)="NuevaClase(content11)"><i class="fa fa-plus"></i> Nuevo
                        </button>

                    </div>

                </div>

                <div class="modal-body">
                    <div class="table-responsive">
                        <table class="table table-sm table-striped table-bordered m-t-20 table-hover">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Clase</th>
                                    <th>Descripción</th>
                                    <th>Código</th>
                                    <th>Descripción código</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let lst of contactoClases">
                                    <td scope="row"
                                        style="display: table-cell; text-align: center; padding-bottom: 0px;">
                                        <div class="btn-group btn-group-xs" role="group"
                                            style="margin: 0px;padding: 0px;">
                                            <!--<button disabled type="button" class="btn btn-sm"><span
                                                    class="fas fa-pencil-alt"
                                                    (click)="openModalClasesUpdate(lst,content12)"
                                                    aria-hidden="true"></span></button>-->
                                            <button type="button" class="btn btn-sm "><span class="fas fa-trash-alt"
                                                    (click)="deleteContactoClaseCliente(lst)"
                                                    aria-hidden="true"></span></button>
                                        </div>
                                    </td>
                                    <td>{{lst.clase}}</td>
                                    <td>{{lst.claseDesc}}</td>
                                    <td>{{lst.codigo}}</td>
                                    <td>{{lst.codigoDesc}}</td>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

            </ng-template>

            <ng-template #content11 let-modal>
                <div class="modal-header">
                    <h4 class="modal-title" id="modal-basic-title">Nueva clase</h4>
                    <button tabindex="1004" type="button" class="close" aria-label="Close"
                        (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form action="" #form="ngForm" autocomplete="off">
                        <div class="form-row">
                            <div class="col-md-12">
                                <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                                    <label class="col-md-2 label-size tsiLabel mt-2">Clase</label>
                                    <input class="form-control tsiInput col-md-2 m-r-5" id="codClase" name="codClase"
                                        [(ngModel)]="codClase" type="text" tabindex="1005" maxlength="3">
                                    <select class=" tsiSelect col-md-7" tabindex="1006" id="cboClase" name="codClase"
                                        [(ngModel)]="codClase" (change)="onChangeClases($event.target.value)">
                                        <option *ngFor="let clases of clasesCombo" value="{{clases.codigo}}">
                                            {{clases.descri}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-md-12">
                                <div class="form-group row d-flex align-items-center" style="margin-bottom: 0px">
                                    <label class="col-md-2 label-size tsiLabel mt-2">Código</label>
                                    <input class="form-control tsiInput col-md-2 m-r-5" id="codCodigoClase"
                                        name="codCodigoClase" [(ngModel)]="codCodigoClase" [disabled]="!disabledcodigos"
                                        type="text" tabindex="1007" maxlength="3">
                                    <select class="tsiSelect col-md-7" tabindex="1008" id="cboCodigoClase"
                                        name="codCodigoClase" [(ngModel)]="codCodigoClase"
                                        [disabled]="!disabledcodigos">
                                        <option *ngFor="let cod of claseCodigos" value="{{cod.codigo}}">{{cod.descri}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-rounded btn-info m-b-15" (click)="nuevaClase();"
                        tabindex="1009"><i class="fa fa-save"></i> Guardar</button>
                    <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                        (click)="modal.close('Save click')" tabindex="1010"><i class="fa fa-times-circle"></i>
                        Cancelar</button>
                </div>
            </ng-template>
            <!--Modificar Clase-->
            <ng-template #content12 let-modal>
                <div class="modal-header">
                    <h4 class="modal-title" id="modal-basic-title">Modificar Clase:</h4>
                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form action="" #form="ngForm" autocomplete="off">
                        <div class="form-row">
                            <div class="col-md-12">
                                <div class="input-group" style="margin-bottom: 0.5rem;">
                                    <label style="margin-right: 2.4rem">Clase</label>
                                    <input disabled class="form-control form-control-sm col-md-2 m-r-5" id="codClase"
                                        name="codClase" [(ngModel)]="codClase" type="text" tabindex="1004"
                                        maxlength="3">
                                    <select disabled class=" tsiSelect col-md-7" tabindex="1005" id="cboClase"
                                        name="codClase" [(ngModel)]="codClase"
                                        (change)="onChangeClases($event.target.value)">
                                        <option *ngFor="let clases of clasesCombo" value="{{clases.codigo}}">
                                            {{clases.descri}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-md-12">
                                <div class="input-group" style="margin-bottom: 0.5rem;">
                                    <label style="margin-right: 1.5rem">Código</label>
                                    <input class="form-control form-control-sm col-md-2 m-r-5" id="codCodigoClase"
                                        name="codCodigoClase" [(ngModel)]="codCodigoClase" type="text" tabindex="1004"
                                        maxlength="3">
                                    <select class=" tsiSelect col-md-7" tabindex="1005" id="cboCodigoClase"
                                        name="codCodigoClase" [(ngModel)]="codCodigoClase">
                                        <option *ngFor="let cod of claseCodigos" value="{{cod.codigo}}">{{cod.descri}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-rounded btn-info m-b-15" (click)="modificarClase();"
                        tabindex="5"><i class="fa fa-save"></i> Guardar</button>
                    <button type="button" class="btn btn-rounded btn-warning m-b-15" (click)="closeInsert()"
                        (click)="modal.close('Save click')" tabindex="6"><i class="fa fa-times-circle"></i>
                        Cancelar</button>
                </div>
            </ng-template>
        </ngb-tab>

    </ngb-tabset>
</div>